import { isFormFieldNode } from '@builder4/shared/components/Form/formRegistry';

interface BaseHiddenActions {
  setProp: (nodeId: string, callback: (props: { hidden?: boolean }) => void) => void;
  setHidden: (nodeId: string, hidden: boolean) => void;
}

/**
 * Sets the hidden state for a node, using the correct mechanism based on node type.
 * Form fields use props.hidden (CSS hiding) to stay in DOM for form submission.
 * Other nodes use data.hidden (CraftJS layer visibility).
 *
 * @param actions - CraftJS editor actions (or merged actions from history.merge())
 * @param nodeId - The node ID to update
 * @param displayName - The node's display name (used to determine if it's a form field)
 * @param hidden - The hidden state to set
 */
export const setNodeHidden = (
  actions: BaseHiddenActions,
  nodeId: string,
  displayName: string,
  hidden: boolean,
): void => {
  if (isFormFieldNode(displayName)) {
    actions.setProp(nodeId, (props: { hidden?: boolean }) => {
      props.hidden = hidden;
    });
  } else {
    actions.setHidden(nodeId, hidden);
  }
};

/**
 * Gets the current hidden state for a node based on node type.
 * Form fields use props.hidden, other nodes use data.hidden.
 */
export const getNodeHidden = (
  displayName: string,
  propsHidden: boolean | undefined,
  dataHidden: boolean | undefined,
): boolean => {
  if (isFormFieldNode(displayName)) {
    return propsHidden ?? false;
  }
  return dataHidden ?? false;
};
